import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLeadCreateForm } from '../hooks/use-lead-create-form.js';
import LeadForm from './lead-form.jsx';

function LeadCreatePageContainer() {
  const { t } = useTranslation();
  const state = useLeadCreateForm();

  return (
    <div>
      <div className="app-page-header d-flex align-items-start justify-content-between gap-3">
        <div>
          <h2>{t('leads.createLeadTitle')}</h2>
          <p>{t('leads.subtitle')}</p>
        </div>
        <Link to="/leads" className="btn btn-outline-secondary d-flex align-items-center">
          <i className="ti ti-arrow-left me-1 fs-5"></i>
          {t('common.back')}
        </Link>
      </div>

      <div className="card">
        <LeadForm
          form={state.form}
          formErrors={state.formErrors}
          error={state.error}
          isSaving={state.isSaving}
          isLoadingDetails={false}
          countryOptions={state.countryOptions}
          onChange={state.onLeadFormChange}
          onAddDetail={state.addLeadDetailRow}
          onRemoveDetail={state.removeLeadDetailRow}
          onSubmit={state.saveLeadForm}
          onCancel={state.cancelLeadForm}
          bodyClassName="card-body"
          actionsClassName="card-footer d-flex justify-content-end gap-2"
        />
      </div>
    </div>
  );
}

export default LeadCreatePageContainer;
